import { render, staticRenderFns } from "./VInTree.vue?vue&type=template&id=6b6f3d24"
import script from "./VInTree.vue?vue&type=script&lang=js"
export * from "./VInTree.vue?vue&type=script&lang=js"
import style0 from "./VInTree.vue?vue&type=style&index=0&id=6b6f3d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports